// Live connection state (V0.4.15, spec Live Block R1.2 §4) — pure rules, unit-tested in test/connection-check.mts.
export type LiveStatus = 'live' | 'connecting' | 'reconnecting' | 'offline';

export const BEAT_MS = 5000; // heartbeat every 5 s while the tab is visible
export const LIVE_MS = 12000; // last pass younger than this → live
export const OFFLINE_MS = 30000; // no pass for this long → offline

export type ConnFacts = {
  now: number;
  startedAt: number; // first check after load / sign-in
  lastPassAt: number | null;
  missed: boolean; // the last check failed (or was slower than 5 s)
  online: boolean; // navigator.onLine
};

export function deriveStatus(f: ConnFacts): LiveStatus {
  if (!f.online) return 'offline';
  if (f.lastPassAt === null) return f.now - f.startedAt >= OFFLINE_MS ? 'offline' : f.missed && f.now - f.startedAt > LIVE_MS ? 'reconnecting' : 'connecting';
  const age = f.now - f.lastPassAt;
  if (age >= OFFLINE_MS) return 'offline';
  if (f.missed || age >= LIVE_MS) return 'reconnecting';
  return 'live';
}

/** A heartbeat passes only if the realtime channel is joined AND the database answered in time. */
export const passes = (channelJoined: boolean, pingOk: boolean, pingMs: number) => channelJoined && pingOk && pingMs <= BEAT_MS;
